<template>
  <div class="image-select-btn" v-show="params.flag">
    <div class="btn-list">
      <div class="btn">
        <el-button
          :class="{ activate: type === 't_B.png' }"
          @click="handleElementClick('t_B.png')"
          class="element-btn"
          size="mini"
          >气温</el-button
        >
      </div>
      <div class="btn">
        <el-button
          :class="{ activate: type === 'r01h_B.png' }"
          @click="handleElementClick('r01h_B.png')"
          class="element-btn"
          size="mini"
          >1小时降水</el-button
        >
      </div>
      <div class="btn">
        <el-button
          :class="{ activate: type === 'r03h_B.png' }"
          @click="handleElementClick('r03h_B.png')"
          class="element-btn"
          size="mini"
          >3小时降水</el-button
        >
      </div>
      <div class="btn">
        <el-button
          :class="{ activate: type === 'r06h_B.png' }"
          @click="handleElementClick('r06h_B.png')"
          class="element-btn"
          size="mini"
          >6小时降水</el-button
        >
      </div>
      <div class="btn">
        <el-button
          :class="{ activate: type === 'wd3smaxdf_B.png' }"
          @click="handleElementClick('wd3smaxdf_B.png')"
          class="element-btn"
          size="mini"
          >风力风向</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import ImageLayer from "ol/layer/Image";
import ImageStatic from "ol/source/ImageStatic";

const dataUrl = process.env.VUE_APP_DATA;
export default {
  props: ["params"],
  data() {
    return {
      type: "",
      layer: "",
    };
  },
  watch: {
    /**
     * 监听当前索引，切换图层
     * @param {Number} index
     */
    currentIndex(index) {
      this.setSource(index);
    },
    "params.flag": {
      handler(newVal) {
        if (!newVal) {
          this.hide();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.init();
  },

  mounted() {},
  methods: {
    /**
     * 初始化
     */
    async init() {},
    /**
     * 设置图片叠加到地图
     */
    setSource(index) {},
    hide() {
      this.type = "";
      this.layer && this.layer.setVisible(false);
    },
    /**
     * 获取数据
     */
    getData() {},
    handleElementClick(type) {
      if (this.type !== type) {
        this.type = type;
        const imgUrl = dataUrl + "/livePic_fs/" + this.type;
        if (!this.layer) {
          this.layer = new ImageLayer({
            zIndex: 10,
            opacity: 0.7,
          });
          this.params.map2d.map.addLayer(this.layer);
        }
        const source = new ImageStatic({
          url: imgUrl,
          imageExtent: [112.371779198, 22.60077104, 113.410095829, 23.61034945],
        });
        this.layer.setSource(source);
        this.layer.setVisible(true);
      } else {
        this.type = "";
        this.layer.setVisible(false);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.image-select-btn {
  position: absolute;
  right: 25vw;
  top: calc(19vh);
  transform: translateX(-50%);
  color: #fff;
  box-sizing: border-box;

  .btn-list {
    display: flex;
    flex-direction: column;

    .btn {
      margin-bottom: 5px;

      /deep/ .el-button {
        width: 100%;
        background-color: rgba(37, 78, 135, 0.6);
        color: #fff;
      }

      .activate {
        border-color: #08d3ee;
        color: #08d3ee;
      }
    }
  }
}
</style>
